export const locales = [
  {
    code: 'es-ES',
    shortCode: 'es',
    name: 'Español (ES)'
  },
  {
    code: 'es-AR',
    shortCode: 'es',
    name: 'Español (AR)'
  },
  {
    code: 'es-CL',
    shortCode: 'es',
    name: 'Español (CL)'
  },
  {
    code: 'es-CO',
    shortCode: 'es',
    name: 'Español (CO)'
  },
  {
    code: 'es-MX',
    shortCode: 'es',
    name: 'Español (MX)'
  },
  {
    code: 'ca-ES',
    shortCode: 'ca',
    name: 'Català (ES)'
  },
  {
    code: 'ca-AD',
    shortCode: 'ca',
    name: 'Català (AD)'
  },
  {
    code: 'eu-ES',
    shortCode: 'eu',
    name: 'Euskara'
  },
  {
    code: 'en-US',
    shortCode: 'en',
    name: 'English'
  },
  {
    code: 'fr-FR',
    shortCode: 'fr',
    name: 'Français'
  },
  {
    code: 'it-IT',
    shortCode: 'it',
    name: 'Italiano'
  }
]
export const defaultLocale = locales.find(({ code }) => code === 'en-US')
export const parseLocale = someString => {
  const normalize = value => value.toLowerCase().replace('_', '-')
  const normalized = normalize(someString)
  return locales.find(({ code }) => normalize(code).startsWith(normalized)) || defaultLocale
}

export default locales
